import React, {useEffect, useState} from 'react';
import logo from '../../images/Techsee_logo_blue.png';
import logout from '../../images/logout.png';
import {storageService} from '../../services/storageService';

const Profile = (props) => {
    const [openMenu, setOpen] = useState(false);
    const [user, setUser] = useState<string>('');
    const {logOut} = props.siaStore;

    useEffect(() => {
        setUser(storageService.loadFromStorage('username'));
    }, []);

    return (
        <>
            <div className='profile-container position-right-header pointer' onClick={() => setOpen(!openMenu)}>
                <img id='logo' className='main-logo-img margin-right-sm-vw' src={logo} alt='techSee-logo' />
                <div className='blue-userName' ><p className='p-userName'>{user[0]}</p></div>
            </div>
            {openMenu && <div className='profile-menu position-right-header'>
                <div id='user-name-border' className='inner-menu'>
                    <p>{user}</p>
                </div>
                <div className='inner-menu pointer' onClick={() => logOut(false)}>
                    <img alt='exit' className='px-22-icon-img' src={logout}/>
                    <p className='log-out-p'>Logout</p>
                </div>
            </div>}
        </>
    );

};

export default Profile;
